import {Component, OnDestroy, OnInit} from '@angular/core';
import {Axes} from "../../../../models/axes";
import {AxesService} from "../../../../services/axes/axes.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Editor} from "ngx-editor";

@Component({
  selector: 'app-axes',
  templateUrl: './axes.component.html',
  styleUrls: ['./axes.component.scss']
})
export class AxesComponent implements OnInit, OnDestroy {
  axes: Array<Axes>;
  form: FormGroup;
  loading: boolean;

  editor: Editor;
  html: string = '';

  constructor(private axeService: AxesService, private modalService: NgbModal, private fb: FormBuilder) { }

  ngOnInit() {
    this.editor = new Editor();
    this.form = this.fb.group({
      name: this.fb.control(null, [Validators.required]),
      description: this.fb.control(null, [Validators.required]),
      action_user: this.fb.control(null, []),
    });
    this.axeService.list().subscribe(data => this.axes = data);
  }

  ngOnDestroy() {
    this.editor.destroy();
  }

  open(content) {
    this.modalService.open(content, {
      ariaLabelledBy: "modal-basic-title",
      backdrop: "static",
      size: "lg",
      windowClass: 'custom-modal',
    });
  }

  onSubmit() {
    if (this.form.invalid) {
      for (const control of Object.keys(this.form.controls)) {
        this.form.controls[control].markAsTouched();
      }

      return;
    }
  }
}
